import STORE from '../../store';
import invalidateMetricCache from '../metrics/invalidateMetricCache';

const updateCompoundMetric = async (
  id: string,
  newMetric: Metrics.CompoundMetric,
  selectedAccountId: string,
) => {
  await STORE.metricDefinitions
    .getCompoundMetricsRef({ accountId: selectedAccountId })
    .doc(id)
    .set(newMetric);

  await invalidateMetricCache({
    accountId: selectedAccountId,
    compoundMetricIds: [id],
  });
};

export default updateCompoundMetric;
